import React from 'react';
import { createRoot } from 'react-dom/client';

import NewSessisonPanel from './components/Panel';
import AuthScreenLayout from '../../components/AuthScreenLayout';

import { isSupportedBrowser } from '../../common/utils';
import UnsupportedBrowsers from '../../components/UnsupportedBrowsers';

const createNewSessiosScreen = ({ referrerLink }) => {
  const root = createRoot(document.getElementById('newSessionPanel'));
  if (isSupportedBrowser()) {
    root.render(
      <AuthScreenLayout>
        <NewSessisonPanel referrerLink={referrerLink} />
      </AuthScreenLayout>
    );
  } else {
    root.render(<UnsupportedBrowsers />);
  }
};

window.createNewSessiosScreen = createNewSessiosScreen;
